export default "__VITE_ASSET__Bpim04yT__"